import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import('@/view/pages/Dashboard.vue'),
          meta: {
            title: 'Dashboard'
          }
        },
      ],
    },

    {
      path: '/statistics',
      redirect: '/statistics/grafana',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/statistics/grafana',
          name: 'StatisticsGrafana',
          component: () => import('@/view/pages/statistics/StatisticsGrafana.vue'),
          meta: {
            title: 'Grafana'
          }
        },
        {
          path: '/statistics/webhooks',
          name: 'StatisticsWebhooks',
          component: () => import('@/view/pages/statistics/StatisticsWebhooks.vue'),
          meta: {
            title: 'Webhooks'
          }
        },
      ],
    },

    {
      path: '/servers',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/servers',
          name: 'ServersList',
          component: () => import('@/view/pages/servers/ServersList.vue'),
          meta: {
            // dispatchBefore: 'getCountries'
            title: 'Servers'
          },
        },
        {
          path: '/servers/install',
          name: 'ServersRecipeInstall',
          component: () => import('@/view/pages/servers/ServersRecipeInstall.vue'),
          meta: {
            title: 'Install Recipe'
          }
        },
        {
          path: '/servers/vpn/:id',
          name: 'ServersVpnManage',
          component: () => import('@/view/pages/servers/ServersVpnManage.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ServersList' })
          },
          meta: {
            title: 'VPN Servers'
          }
        },
        {
          path: '/servers/cloudflare/:id',
          name: 'ServersCloudflare',
          component: () => import('@/view/pages/servers/ServersCloudflare.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ServersList' })
          },
          meta: {
            title: 'Cloudflare Configuration'
          }
        },
      ],
    },

    {
      path: '/resellers',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/resellers',
          name: 'ResellersList',
          component: () => import('@/view/pages/resellers/ResellersList.vue'),
          meta: {
            title: 'Resellers'
          }
        },
        {
          path: '/resellers/:id/integrations',
          name: 'ResellerIntegrations',
          component: () => import('@/view/pages/resellers/ResellerIntegrations.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ResellersList' })
          },
          meta: {
            title: 'Reseller Integrations'
          }
        },
        {
          path: '/resellers/:id/integrations/api',
          name: 'ResellerApi',
          component: () => import('@/view/pages/resellers/ResellerApi.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ResellersList' })
          },
          meta: {
            title: 'API Integration'
          }
        },
        {
          path: '/resellers/:id/integrations/webhook',
          name: 'ResellerWebhook',
          component: () => import('@/view/pages/resellers/ResellerWebhook.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ResellersList' })
          },
          meta: {
            title: 'Webhook Integration'
          }
        },
        {
          path: '/resellers/:id/integrations/revenuecat',
          name: 'ResellerRevenuecat',
          component: () => import('@/view/pages/resellers/ResellerRevenuecat.vue'),
          beforeEnter(to, _, next) {
            if (to.params.id !== undefined) next()
            else next({ name: 'ResellersList' })
          },
          meta: {
            title: 'RevenueCat Integration'
          }
        },
      ],
    },

    {
      path: '/users',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/users',
          name: 'UsersList',
          component: () => import('@/view/pages/users/UsersList.vue'),
          meta: {
            title: 'Users'
          }
        },
      ],
    },

    {
      path: '/tools',
      redirect: '/tools/news',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/tools/news',
          name: 'ToolsNews',
          component: () => import('@/view/pages/tools/ToolsNews.vue'),
          meta: {
            title: 'News'
          }
        },
        {
          path: '/tools/log-search',
          name: 'ToolsLogSearch',
          component: () => import('@/view/pages/tools/ToolsLogSearch.vue'),
          meta: {
            title: 'Log Search'
          }
        },
        {
          path: '/tools/console',
          name: 'ToolsConsole',
          component: () => import('@/view/pages/tools/ToolsConsole.vue'),
          meta: {
            title: 'Console'
          }
        },
      ],
    },

    {
      path: '/',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/notifications',
          name: 'Notifications',
          component: () => import('@/view/pages/notifications/Notifications.vue'),
          meta: {
            title: 'Notifications'
          }
        },
      ],
    },

    {
      path: '/profile',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/profile',
          name: 'Profile',
          component: () => import('@/view/pages/profile/Profile.vue'),
          meta: {
            title: 'My Profile'
          }
        },
      ],
    },

    {
      path: '/settings',
      redirect: '/settings/general',
      component: () => import('@/view/layout/Layout'),
      children: [
        {
          path: '/settings/general',
          name: 'SettingsGeneral',
          component: () => import('@/view/pages/settings/settings-general/SettingsGeneral.vue'),
          meta: {
            title: 'General Settings'
          }
        },
        {
          path: '/settings/tariffs',
          name: 'SettingsTariffs',
          component: () => import('@/view/pages/settings/settings-tariffs/SettingsTariffs.vue'),
          meta: {
            title: 'Tariffs'
          }
        },
        {
          path: '/settings/groups',
          name: 'SettingsGroups',
          component: () => import('@/view/pages/settings/settings-groups/SettingsGroups.vue'),
          meta: {
            title: 'Groups'
          }
        },
        {
          path: '/settings/firewalls',
          name: 'SettingsFirewalls',
          component: () => import('@/view/pages/settings/settings-firewalls/SettingsFirewalls.vue'),
          meta: {
            title: 'Firewalls'
          }
        },
        {
          path: '/settings/vpn-servers',
          name: 'SettingsVpnServers',
          component: () => import('@/view/pages/settings/settings-vpn-servers/SettingsVpnServers.vue'),
          meta: {
            title: 'VPN Servers'
          }
        },
        {
          path: '/settings/recipes',
          name: 'SettingsRecipes',
          component: () => import('@/view/pages/settings/settings-recipes/SettingsRecipes.vue'),
          meta: {
            title: 'Recipes'
          }
        },
        {
          path: '/settings/recipes-groups',
          name: 'SettingsRecipesGroups',
          component: () => import('@/view/pages/settings/settings-recipes-groups/SettingsRecipesGroups.vue'),
          meta: {
            title: 'Recipe Groups'
          }
        },
        {
          path: '/settings/macroses/',
          name: 'SettingsMacroses',
          component: () => import('@/view/pages/settings/settings-macroses/SettingsMacroses.vue'),
          meta: {
            title: 'Macros Variables'
          }
        },
        {
          path: '/settings/countries',
          name: 'SettingsCountries',
          component: () => import('@/view/pages/settings/settings-countries/SettingsCountries.vue'),
          meta: {
            title: 'Countries'
          }
        },
      ],
    },

    {
      name: 'login',
      path: '/auth',
      component: () => import('@/view/pages/auth/Login'),
      meta: {
        title: 'Sign In'
      }
    },

    {
      path: '*',
      redirect: '/404',
    },

    {
      // the 404 route, when none of the above matches
      path: '/404',
      name: '404',
      component: () => import('@/view/pages/error/P404.vue'),
      meta: {
        title: 'Oops...'
      }
    },
  ],
})
